import Renderer from 'packages/lightbox/ModalRoot.react';
import {
    listenOnSessionChanges,
    listenOnSignIn,
    listenOnSignOut,
    LoadSession,
    unlistenOnSessionChanges,
    unlistenOnSignIn,
    unlistenOnSignOut,
} from 'packages/session/session';
import {Fragment, useEffect, useState} from 'react';
import ReactTooltip from 'react-tooltip';
import RouterApp from './router.react';
import useOnce from 'packages/hooks/useOnce';
import CookiesFull from 'packages/cookies/cookiesFull.react';
import {IsNecessaryCookieEnabled, IsThirdPartyCookieEnabled} from 'packages/cookies/utils/IsCookieEnabled';
import ToastContainer from 'packages/toasts/Container.react';

export default function App() {
    const [Loading, SetLoading] = useState(true);
    const [Reload, SetReload] = useState(false);

    useOnce(() => {
        async function Init() {
            try {
                await LoadSession();
                SetLoading(false);
            } catch (error) {
                console.log(error);
            }
        }

        Init();
    });

    const loadMetaPixel = (id: string) => {
        if (typeof window === 'undefined' || (window as any).__mpLoaded) return;
        (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = true;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = true;
            t.defer = true;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        (window.fbq as any)?.('consent', 'grant');
        window.fbq?.('init', id);
        window.fbq?.('track', 'PageView');
        (window as any).__mpLoaded = true;
    };

    useOnce(() => {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }

        if (!IsNecessaryCookieEnabled()) {
            return;
        }
        const scriptRecap = document.createElement('script');
        scriptRecap.src = 'https://www.google.com/recaptcha/api.js?render=6LdohvkqAAAAAHQmV1hzDpPXHm0ZE282cj2pXyeL';
        document.body.appendChild(scriptRecap);

        if (!IsThirdPartyCookieEnabled()) {
            return;
        }

        if (process.env.NODE_ENV === 'production') {
            loadMetaPixel('796153141996284');
        }
    });

    function onSessionChange() {
        SetReload(!Reload);
    }

    useEffect(() => {
        listenOnSessionChanges(onSessionChange);
        listenOnSignIn(onSessionChange);
        listenOnSignOut(onSessionChange);

        return () => {
            unlistenOnSessionChanges(onSessionChange);
            unlistenOnSignIn(onSessionChange);
            unlistenOnSignOut(onSessionChange);
        };
    });

    if (Loading) {
        return null;
    }

    return (
        <Fragment>
            <Renderer />
            <RouterApp />
            <ToastContainer />
            <ReactTooltip />
            <CookiesFull />
        </Fragment>
    );
}
